import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { FormConfigurationDto } from "../../types/FormConfigurationDto";
import type { FormConfigurationEntity } from "../../types/FormConfigurationEntity";
import { FormConfigurationDtoToEntity } from "../mappers/FormConfigurationDtoToEntity";

export const formConfigApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadFormDefinition: builder.query<FormConfigurationEntity, string>({
            providesTags: ["mainCache"],
            query: (formId) => {
                const dataGroup = getAssignedDataGroup();
                const dataGroupCode = dataGroup?.code;
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/form-configurations/${formId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: FormConfigurationDto) => {
                return FormConfigurationDtoToEntity(response);
            },
        }),
    }),
});

export const { useLoadFormDefinitionQuery } = formConfigApi;
